import React from 'react';
import Theory from '../theory';

function TheoryPage() {
    return (
        <Theory />
    )
}

export default TheoryPage;